import Vue from 'vue'

const state = {
    current: 'my',
    family: {
        listData: {
            data: [
                { key: 'my', label: Vue.prototype.$t("code-lab/component/layout/control-menue/observable.js_0"), svg$: '#t-code-file-manage-cloud', is: 1, active$: '' },
                
            ],
            class: {
                item: 'text-a:c; font:14px; c:#fff; py:22px; hover:bgc:#444; active:c:#0ed3ff; letter-s:.86px;',
                wrapper: ''
            },
            shit: {
                itemWrapper: 'dis:f; align-i:c; pl:20px;',
                label: 'ml:10px;'
            }
        },
    },
    teacher: {
        listData: {
            data: [
                { key: 'my', label: Vue.prototype.$t("code-lab/component/layout/control-menue/observable.js_1"), svg$: '', is: 1, active$: '' },
                { key: 'shared', label: Vue.prototype.$t("code-lab/component/layout/control-menue/observable.js_2"), svg$: '', is: 2, active$: '' },
            ],
            class: {
                item: 'h:40px; lh:40px; text-a:c; font:12px; c:#fff; hover:bgc:#444; active:c:#0ed3ff; letter-s:.86px;',
                wrapper: ''
            },
            shit: {
                itemWrapper: 'dis:f; align-i:c; pl:56px;',
                label: ''
            }
        },
    }
}

export const store = Vue.observable(state)

export const mutations = {
    current (payload) {
        Object.assign(store, { current: payload })
    }
}